import React, { useEffect, useState } from 'react'
import Config from '../Config';
import Toastmodal from '../Toastmodal';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';

function Propertytypeedit() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let navigate = useNavigate();
    let { id } = useParams();

    const [banner , setBanner] = useState([]);
  
   const [toastmodal, setToastmodal] = useState(false);
   const [toastmessage, setToastmessage] = useState("");
   const [toasttype, setToasttype] = useState("");
   const [toastlarge, setToastlarge] = useState(false);
  
   const [formerror, setError] = useState({});
  
  let name , value;
  
  const  handleInputs = (e) =>{
       name = e.target.name;
       value = e.target.value;
       setBanner({...banner,[name]:value});
   } 
   
   const onFileChange = (e)=>{
     let name = e.target.name;
     setBanner({ ...banner,[name]: e.target.files[0] });
   };


   const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/property-types/get-property-type/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();
      setBanner(data.data);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      console.log("error");
    }
  };

  
 
  
   const PostData = async (e) => {
     e.preventDefault();
     let formvalid=true;
     const errors = {};
    if (!banner.propertyType) {
      errors.propertyType = "Property type is required!";
      formvalid=false;
    }
  
    if (!banner.propertyTypeCategory) {
      errors.propertyTypeCategory = "Property type category is required!";
      formvalid=false;
    }
    if (!banner.status) {
      errors.status = "status is required!";
      formvalid=false;
    } 
    
    if (!banner.canonicalURL) {
      errors.canonicalURL = "Canonical URL is required!";
      formvalid=false;
    } 
    if (!banner.metaDescription) {
      errors.metaDescription = "Meta description is required!";
      formvalid=false;
    } 
    if (!banner.metaTitle) {
      errors.metaTitle = "Meta title is required!";
      formvalid=false;
    } 
    if (!banner.file) {
      if(!banner.fileUploadPath){
        errors.file = "File is required!";
        formvalid=false;
      }
    } 
    else{
      
        if (
          banner.file.type === "image/jpeg" ||
          banner.file.type === "image/jpg" ||
          banner.file.type === "image/png" ||
          banner.file.type === "image/webp" 
        ) {
          if (banner.file.size > 1024 * 1000) {
            errors.file =
              "maximum file size 1 mb...please upload an image less than 1 mb";
              formvalid=false;
          }
        } else {
          errors.file = "Only support jpg, jpeg, png, webp image!";
          formvalid=false;
        }
      
    
    }

    if (!banner.fileUploadPathWeb && !banner.webimage) {
    
        errors.webimage = "File is required!";
        formvalid=false;
     
    } 
    else if(banner.webimage){
        if (
          banner.webimage.type === "image/jpeg" ||
          banner.webimage.type === "image/jpg" ||
          banner.webimage.type === "image/png" ||
          banner.webimage.type === "image/webp" 
        ) {
          if (banner.webimage.size > 1024 * 1000) {
            errors.webimage =
              "maximum file size 1 mb...please upload an image less than 1 mb";
              formvalid=false;
          }
        } else {
          errors.webimage = "Only support jpg, jpeg, png, webp image!";
          formvalid=false;
        }
      
    
    }
  
     setError(errors);
    if(formvalid===true){
        const formData = new FormData();
        formData.append("propertyType",banner.propertyType);
        formData.append("propertyTypeCategory",banner.propertyTypeCategory);
        formData.append("status",banner.status);
        formData.append("metaTitle",banner.metaTitle);
        formData.append("metaDescription",banner.metaDescription);
        formData.append("canonicalURL",banner.canonicalURL);
        if(banner.file){
          formData.append("file",banner.file);
        }
        else{
          formData.append("oldImage",banner.fileUploadPath);
        }
        if(banner.webimage){
          formData.append("fileforWeb",banner.webimage);
        }
        else{
          formData.append("oldImageWeb",banner.fileUploadPathWeb);
        }
        axios
        .put(`${Config.apiurl}/api/v1/crm/property-types/update-property-type-info/${id}`, formData,{ headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",
        },}).then((res) => {

          if (res.status === 200 ){
            setToastmodal(true);
            setToastmessage("Sucessfully updated Property type");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);
          }
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage("Something went wrong!");
            setToasttype("error");
            setToastlarge(false);
          }
        });
      }
   };

   useEffect(()=>{
    getinfo();
   },[])
  return (
    <div>
        <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Property Type</h4>
                        <p className="card-description">Add New Property Type</p>
                        <form className="forms-sample" onSubmit={PostData}>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Type</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Type"
                              name="propertyType"
                              value={banner.propertyType}
                              onChange={handleInputs}
                            />
                               <label style={{ color: "red" }}>{formerror.propertyType}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Type Category</label>
                            <select className="form-select" name="propertyTypeCategory" value={banner.propertyTypeCategory} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value='Residential'>Residential</option>
                            <option value='Commercial'>Commercial</option>
                            </select>

                           
                           <label style={{ color: "red" }}>{formerror.propertyTypeCategory}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Canonical URL</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Canonical URL"
                              name="canonicalURL"
                              value={banner.canonicalURL}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.canonicalURL}</label>
                          </div>
                          
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Mobile image</label>
                            <br></br>
                            <input type="file" name="file" onChange={onFileChange} />
                            <div className='clearfix'></div>
                            {banner.fileUploadPath?
                        <img src={banner.fileUploadPath} style={{width:"100px",height:"100px",marginTop:"10px"}}/>
                        :
                       ""
                        }
                            <label style={{ color: "red" }}>{formerror.file}</label>
                          </div>


                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Website image</label>
                            <br></br>
                            <input type="file" name="webimage" onChange={onFileChange} />
                            <div className='clearfix'></div>
                            {banner.fileUploadPathWeb?
                        <img src={banner.fileUploadPathWeb} style={{width:"100px",height:"100px",marginTop:"10px"}}/>
                        :
                       ""
                        }
                            <label style={{ color: "red" }}>{formerror.webimage}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Meta Title</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Meta Title"
                              name="metaTitle"
                              value={banner.metaTitle}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.metaTitle}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Meta Description</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Meta Description"
                              name="metaDescription"
                              value={banner.metaDescription}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.metaDescription}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Status</label>
                            <select className="form-select" name="status" value={banner.status} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>

                           </select>
                           <label style={{ color: "red" }}>{formerror.status}</label>
                          </div>
                          <button
                            type="submit"
                            onClick={PostData}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>

                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
      </div>
  )
}

export default Propertytypeedit
